import { c as copy_payload, a as assign_payload, p as pop, b as push } from "../../../../chunks/hooks.server.js";
import "../../../../chunks/index2.js";
import { L as Label, I as Input } from "../../../../chunks/label.js";
import { F as Fa } from "../../../../chunks/fa.js";
/* empty css                                                              */
import { faShieldHalved, faUser, faLock, faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import "../../../../chunks/client.js";
import { B as Button } from "../../../../chunks/button.js";
function _page($$payload, $$props) {
  push();
  let login = "";
  let password = "";
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    $$payload2.out += `<div class="min-h-screen bg-[#111111] flex items-center justify-center p-4"><div class="w-full max-w-md space-y-8"><div class="text-center space-y-2"><div class="flex justify-center"><div class="bg-[#ff6b00]/10 p-4 rounded-full">`;
    Fa($$payload2, {
      icon: faShieldHalved,
      class: "text-[#ff6b00] text-4xl"
    });
    $$payload2.out += `<!----></div></div> <h1 class="text-3xl font-bold text-white">Paneli i Administratorit</h1> <p class="text-gray-400">Shkruani kredencialet per tu futur ne panel.</p></div> <div class="bg-[#1a1a1a] rounded-xl border border-white/10 p-6 space-y-6 shadow-lg">`;
    {
      $$payload2.out += "<!--[!-->";
    }
    $$payload2.out += `<!--]--> <form class="space-y-6"><div class="space-y-2">`;
    Label($$payload2, {
      class: "text-gray-300",
      for: "login",
      children: ($$payload3) => {
        $$payload3.out += `<!---->Username ose Email`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="relative"><div class="absolute left-3 top-1/2 -translate-y-1/2">`;
    Fa($$payload2, { icon: faUser, class: "text-[#ff6b00]" });
    $$payload2.out += `<!----></div> `;
    Input($$payload2, {
      id: "login",
      type: "text",
      placeholder: "Shkruani username ose email",
      class: "pl-10 bg-black/20 border-white/10 focus:border-[#ff6b00] text-white placeholder-gray-500",
      required: true,
      get value() {
        return login;
      },
      set value($$value) {
        login = $$value;
        $$settled = false;
      }
    });
    $$payload2.out += `<!----></div></div> <div class="space-y-2">`;
    Label($$payload2, {
      class: "text-gray-300",
      for: "password",
      children: ($$payload3) => {
        $$payload3.out += `<!---->Password`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----> <div class="relative"><div class="absolute left-3 top-1/2 -translate-y-1/2">`;
    Fa($$payload2, { icon: faLock, class: "text-[#ff6b00]" });
    $$payload2.out += `<!----></div> `;
    Input($$payload2, {
      id: "password",
      type: "password",
      placeholder: "Shkruani passwordin tuaj",
      class: "pl-10 bg-black/20 border-white/10 focus:border-[#ff6b00] text-white placeholder-gray-500",
      required: true,
      get value() {
        return password;
      },
      set value($$value) {
        password = $$value;
        $$settled = false;
      }
    });
    $$payload2.out += `<!----></div></div> `;
    Button($$payload2, {
      type: "submit",
      class: "w-full bg-[#ff6b00] hover:bg-[#ff6b00]/90 text-white",
      children: ($$payload3) => {
        {
          $$payload3.out += "<!--[!-->";
          Fa($$payload3, { icon: faRightToBracket, class: "mr-2" });
        }
        $$payload3.out += `<!--]--> Sign In`;
      },
      $$slots: { default: true }
    });
    $$payload2.out += `<!----></form></div></div></div>`;
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
